<div
  class="tab-pane px-sm-3 px-md-5 {{ isActive() ? 'active' : '' }}"
  role="tabpanel"
  [attr.aria-labelledby]="stepId()"
  [id]="stepId()"
>
  @if(isActive()){
  <ng-content />
  }
</div>
